import { TableSchema } from '../pages/App';

const PRIMARY_KEY_OVERRIDES: Record<string, string> = {
  app_settings: 'key',
  draft_orders: 'order_id',
};

export const getPrimaryKey = (schema: TableSchema): string => {
  const override = PRIMARY_KEY_OVERRIDES[schema.name];
  if (override && schema.columns.some(col => col.key === override)) {
    return override;
  }

  const idColumn = schema.columns.find(col => col.key === 'id');
  if (idColumn) {
    return idColumn.key;
  }

  const fallback = schema.columns.find(col =>
    ['key', 'order_id', 'orderId'].includes(col.key)
  );
  return fallback?.key ?? override ?? 'id';
};
